export default "__VITE_ASSET__BzW3IxnI__"